export const ERROR_MESSAGES = {
  REQUIRED: 'Field is required',
  EMAIL_NOT_VALID: 'Invalid email format',
  PHONE_NOT_VALID: 'Invalid Phone Number',
  PHONE_ALREADY_EXIST: 'Phone Number already exist',
  MAX_LENGTH: max => `Max length is ${max}`,
};
